/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const analyticsScoreBandsDataSchema = z.object({
	bad: z.number(),
	good: z.number(),
	excellent: z.number(),
	unscored: z.number(),
})

export type AnalyticsScoreBandsDataSchema = z.infer<typeof analyticsScoreBandsDataSchema>
